import React from 'react';
import "./Experience.css";
import Resume from '../../assets/JLeMoure_Resume.pdf';
import { FaEye } from 'react-icons/fa';
import FuturecardLogo from '../../assets/futurecard.jpg';
import ForrealLogo from '../../assets/forreal.jpg';

const Experience = () => {
    const experiences = [
        {
            id: 1,
            title: "Software Engineer",
            company: "Future",
            location: "Boston, MA",
            period: "September 2025 - Present",
            description: "Joined a well-funded Series A debit card startup during a restructuring period, taking on ownership across backend systems and the customer-facing web app. Collaborated directly with the CTO and senior engineers during a key growth phase as the platform scaled from 5 million to 50 million transactions and prepared for its next funding round.",
            url: "https://www.futurecard.co",
            logo: FuturecardLogo
        },
        {
            id: 2,
            title: "Software Engineer",
            company: "forREAL",
            location: "Boston, MA",
            period: "June 2024 - September 2025",
            description: "Founding engineer at a seed-funded startup building a remote rental platform connecting applicants and property owners. Worked directly with the CEO to lead technology development across the full stack and bring the product from 0 to 1, launching into production with active users under the company’s proposed revenue model.",
            url: "https://www.myforreal.com",
            logo: ForrealLogo
        }
    ];

    return (
        <section className="experience container section" id="experience">
            <div className="experience__header-main">
                <h2 className="section__title">Experience</h2>
                <a href={Resume} target="_blank" rel="noreferrer" className="btn">
                    <FaEye className="btn__icon" /> View Resume to Learn More
                </a>
            </div>

            <div className="experience__container">
                {experiences.map((experience) => {
                    const Wrapper = experience.url ? 'a' : 'div';
                    const wrapperProps = experience.url
                        ? {
                            href: experience.url,
                            target: '_blank',
                            rel: 'noreferrer',
                            className: 'experience__card experience__card--link',
                            'aria-label': `Open ${experience.company} in a new tab`,
                          }
                        : { className: 'experience__card' };
                    return (
                        <Wrapper key={experience.id} {...wrapperProps}>
                            <div className="experience__header">
                                <div className="experience__header-left">
                                    <h3 className="experience__title">{experience.title}</h3>
                                    <span className="experience__company">
                                        {experience.logo && (
                                            <img
                                                src={experience.logo}
                                                alt={`${experience.company} logo`}
                                                className="experience__company-logo"
                                            />
                                        )}
                                        {experience.company}
                                    </span>
                                    <span className="experience__location">{experience.location}</span>
                                </div>
                                <span className="experience__period">{experience.period}</span>
                            </div>
                            <p className="experience__description">{experience.description}</p>
                        </Wrapper>
                    );
                })}
            </div>
        </section>
    );
};

export default Experience; 